import Icon from "@components/global/new/Icon/Icon";
import styles from "./Algorithm.module.scss";
import cn from "classnames";
import { useIntl } from "react-intl";
import { useLocale } from "@utils/hooks/useLocale";

import bitcoin from "@assets/icons/bitcoin.svg";
import ltc from "@assets/icons/ltc.svg";
import eq from "@assets/icons/equihash.jpg";
import { ALGOS_E } from "@constants/Algos";
import { DetailedHTMLProps, HTMLAttributes, useEffect } from "react";

interface AlgorithmI
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  algo?: ALGOS_E;
  named?: boolean;
  string?: boolean;
  hashName?: string;
  normalizeCase?: boolean;
  login?: string;
  iconSize?: number;
  hideOnError?: boolean;
}

export default function Algorithm({
  algo,
  named,
  string,
  className,
  hashName,
  normalizeCase,
  login,
  iconSize,
  hideOnError,
  ...props
}: AlgorithmI) {

  const { isRus } = useLocale();
  const { formatMessage } = useIntl();
  const algos = {
    all: {
      name: formatMessage({ id: "algo.all" }),
      icon: "",
    },
    sha256: {
      name: "SHA-256",
      icon: bitcoin,
    },
    scrypt: {
      name: "SCRYPT",
      icon: ltc,
    },
    equihash: {
      name: "EQUIHASH",
      icon: eq,
    },
  };

  useEffect(() => {
    console.log("Algorithm render", algo, hashName);
    if (algo && algos[algo]) {
      console.log("Algorithm render", algos[algo]);
    }
  }, [algo]);

  if (!algo || !algos[algo]) {
    if (hideOnError) {
      return null;
    } else {
      return (
        <span className={styles.no_algo}>
          [{formatMessage({ id: "algo.error" })}]
        </span>
      );
    }
  }

  return (
    <div className={cn(styles.wrapper, className)} title={login} {...props}>
      {named && <label>{formatMessage({ id: "algo.label" })}</label>}
      <div
        className={cn(styles.algo, {
          [styles.string]: string,
        })}
      >
        {algos[algo].icon && (
          <Icon
            src={algos[algo].icon}
            className={styles.icon}
            style={iconSize && {
              width: `${iconSize}px`,
              height: `${iconSize}px`
            } || undefined}
          />
        )}
        <label
          style={{
            textTransform:
              normalizeCase || algo === "all" ? "none" : "uppercase",
          }}
        >
          {hashName
            ? hashName === "all"
              ? isRus
                ? "Все"
                : hashName
              : hashName
            : algos[algo]?.name}
        </label>
        {login && <label className={styles.login}>({login})</label>}
      </div>
    </div>
  );
}
